


























import 'reflect-metadata'
import { Mixins, Component, Prop } from 'vue-property-decorator'
import moment from 'moment'
import { toAVAX } from '../../../helper'
import CumulativeBar from './CumulativeBar.vue'
import { IValidator } from '@/store/modules/platform/IValidator'
import { PlatformGettersMixin } from '@/store/modules/platform/platform.mixins'

@Component({
    components: {
        CumulativeBar,
    },
})
export default class ValidatorRow extends Mixins(PlatformGettersMixin) {
    @Prop() validator!: IValidator
    @Prop() cumulativeStake!: number

    get totalStake() {
        const val = this.getTotalStake()
        return toAVAX(parseInt(val.toString()))
    }

    get stakeAmount() {
        return this.validator.stakeAmount
            ? toAVAX(this.validator.stakeAmount)
            : 0
    }

    get stakeAmountText() {
        return this.validator.stakeAmount
            ? toAVAX(this.validator.stakeAmount).toFixed(9)
            : ''
    }

    get stakePerc() {
        return (this.stakeAmount / this.totalStake) * 100
    }

    get stakePercText() {
        // redundant assignments bc referencing computed values affect performance
        const stakeAmount = toAVAX(this.validator.stakeAmount as number)
        const totalStake = toAVAX(parseInt(this.getTotalStake().toString()))
        return ((stakeAmount / totalStake) * 100).toFixed(8)
    }

    get cumulativePercText() {
        const cumulativeStake = toAVAX(this.cumulativeStake)
        const totalStake = toAVAX(parseInt(this.getTotalStake().toString()))
        return ((cumulativeStake / totalStake) * 100).toFixed(0)
    }

    get duration() {
        const endTime = this.validator.endTime.getTime()
        const startTime = this.validator.startTime.getTime()
        const dur = endTime - startTime
        return moment.duration(dur).humanize()
    }
}
